import { Flex, Input, Label } from 'theme-ui';
import CTAButton from '~/components/Generic/CTAButton';
import { forwardRef } from 'react';

const InputWithButton = forwardRef(
  ({ name, theme, placeholder, buttonText, isLoading, forwardSx = {}, ...props }, ref) => {
    const id = name + '-input';

    return (
      <Flex
        sx={{
          backgroundColor: theme === 'dark' ? 'darkGrey' : 'cardGrey',
          borderRadius: '10rem',
          alignItems: 'center',
          fontSize: '1.4rem',
          height: '4rem',
          py: '1.3rem',
          pl: '1.6rem',
          position: 'relative',
          pr: '.6rem',
        }}
      >
        <Input
          ref={ref}
          name={name}
          id={id}
          sx={{
            height: '100%',

            borderRadius: 0,
            px: 0,
            py: '1.3rem',
            '&::placeholder': {
              opacity: 0,
              visibility: 'hidden',
            },
            '&:not(:placeholder-shown) + label': {
              opacity: 0,
              visibility: 'hidden',
            },
            fontSize: 'inherit',
            '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
              WebkitBoxShadow: `0 0 0 30px ${theme === 'dark' ? '#333' : '#e9e9e9'} inset !important`,
            },
            '&:-webkit-autofill': {
              WebkitTextFillColor: `${theme === 'dark' ? 'white' : '#333'} !important`,
            },
            ...forwardSx,
          }}
          variant="text.formInput"
          placeholder={placeholder}
          {...props}
        />

        <Label
          htmlFor={id}
          sx={{
            position: 'absolute',
            left: '1.6rem',
            fontSize: '1.4rem',
            transition: 'opacity 0.3s ease-in-out',
            color: theme === 'dark' ? 'UIGray1' : 'darkGrey',
            pointerEvents: 'none',
            overflow: 'ellipsis',
          }}
        >
          {placeholder}
        </Label>

        <CTAButton
          aria-label={props?.['aria-label']}
          type="submit"
          variant="Filled"
          baseColor={theme === 'dark' ? 'White' : 'Black'}
          size="Small"
          disabled={isLoading}
          forwardSx={{
            zIndex: 1,
          }}
        >
          {buttonText}
        </CTAButton>
      </Flex>
    );
  }
);

export default InputWithButton;
